<template>
    <div>
        <div class="form-group mb-3">
            <div class="form-check">
                <input
                    type="checkbox"
                    class="form-check-input"
                    name="refuse_meals"
                    id="refuse_meals"
                    value="1"
                    :checked="checked"
                    @change="onChange"
                >
                <label class="form-check-label" for="refuse_meals">
                    <slot name="label" />
                </label>
            </div>
        </div>

        <Modal ref="confirmModal" size="modal--mini">
            <div slot="content">
                <p><slot name="confirm-text">{{ confirmMessage }}</slot></p>
                <div>
                    <button type="button" class="btn-cta mr10" @click="confirm">
                        <slot name="confirm-label">OK</slot>
                    </button>
                    <button type="button" class="link" @click="cancel">
                        <slot name="cancel-label">Annuler</slot>
                    </button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from '../layout/Modal.vue';

export default {
    components: { Modal },
    props: {
        initialChecked: { type: Boolean, default: false },
        hasInitialItems: { type: Boolean, default: false },
        confirmMessage: { type: String, default: '' },
        sectionSelector: { type: String, default: '#meal-days-section' },
    },
    data() {
        return {
            checked: this.initialChecked,
        };
    },
    mounted() {
        this.syncVisibility();
    },
    methods: {
        onChange(event) {
            const requested = event.target.checked;
            if (requested && this.hasInitialItems) {
                // Revert visual state until user confirms; modal owns the decision.
                event.target.checked = false;
                this.openModal();
                return;
            }
            this.checked = requested;
            this.syncVisibility();
        },
        confirm() {
            this.checked = true;
            this.closeModal();
            this.syncVisibility();
            this.clearMealQuantities();
        },
        cancel() {
            this.checked = false;
            this.closeModal();
            this.syncVisibility();
        },
        openModal() {
            // Mirror DeleteConfirmButton pattern: re-parent the modal under the root
            // Vue element so its fixed/absolute positioning escapes any local stacking
            // context (parent overflow, transforms, etc.).
            if (!this.$refs.confirmModal.isOpen) {
                this.$root.$el.appendChild(this.$refs.confirmModal.$el);
            }
            this.$refs.confirmModal.toggleModal();
        },
        closeModal() {
            if (this.$refs.confirmModal.isOpen) {
                this.$refs.confirmModal.toggleModal();
            }
        },
        syncVisibility() {
            const section = document.querySelector(this.sectionSelector);
            if (!section) {
                return;
            }
            section.style.display = this.checked ? 'none' : '';
            // Disable every form control inside the section so its values are
            // not submitted while the user opts out. Re-enable when the user
            // un-refuses (section becomes visible again).
            const controls = section.querySelectorAll('input, select, textarea, button');
            controls.forEach((el) => {
                el.disabled = this.checked;
            });
        },
        // When the user confirms the refusal we clear every per-day lunch count
        // so the order summary (left sidebar + recap modal) drops to zero.
        // Matches the @count-changed listener already wired on <lunch-day-meals>.
        clearMealQuantities() {
            const section = document.querySelector(this.sectionSelector);
            if (!section) {
                return;
            }
            const inputs = section.querySelectorAll('input[type="hidden"][name^="lunches["]');
            inputs.forEach((input) => {
                const match = input.name.match(/^lunches\[(\d+)\]$/);
                if (!match) {
                    return;
                }
                input.value = 0;
                const dayId = Number(match[1]);
                if (typeof this.$root.updateOrderItemQuantity === 'function') {
                    this.$root.updateOrderItemQuantity(
                        'ordersummarytable,recap-order-table',
                        'lunch',
                        dayId,
                        0,
                    );
                }
            });
        },
    },
};
</script>
